(() => {
  const root = document.querySelector('[data-lp3]');
  if (!root) return;

  root.querySelectorAll('[data-lp3-scroll]').forEach((button) => {
    button.addEventListener('click', (event) => {
      const target = document.querySelector(button.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      const mobileMenu = root.querySelector('[data-lp3-mobile-menu]');
      const menuToggle = root.querySelector('[data-lp3-menu-toggle]');
      if (mobileMenu && menuToggle) {
        mobileMenu.hidden = true;
        menuToggle.setAttribute('aria-expanded', 'false');
      }
      target.scrollIntoView({behavior: 'smooth', block: 'start'});
    });
  });

  const menuToggle = root.querySelector('[data-lp3-menu-toggle]');
  const mobileMenu = root.querySelector('[data-lp3-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const willOpen = mobileMenu.hidden;
      mobileMenu.hidden = !willOpen;
      menuToggle.setAttribute('aria-expanded', String(willOpen));
    });
  }

  const stage = root.querySelector('[data-lp3-gallery-stage]');
  const galleryThumbs = [...root.querySelectorAll('[data-lp3-gallery-thumb]')];
  const galleryDots = [...root.querySelectorAll('[data-lp3-gallery-dot]')];
  let galleryIndex = 0;
  const setGalleryImage = (index) => {
    if (!stage || !galleryThumbs.length) return;
    galleryIndex = (index + galleryThumbs.length) % galleryThumbs.length;
    const button = galleryThumbs[galleryIndex];
    stage.src = button.dataset.src;
    stage.alt = button.dataset.alt || '';
    galleryThumbs.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === galleryIndex));
    galleryDots.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === galleryIndex));
  };
  galleryThumbs.forEach((button, index) => {
    button.addEventListener('click', () => {
      setGalleryImage(index);
    });
  });
  galleryDots.forEach((button, index) => button.addEventListener('click', () => setGalleryImage(index)));
  root.querySelector('[data-lp3-gallery-prev]')?.addEventListener('click', () => setGalleryImage(galleryIndex - 1));
  root.querySelector('[data-lp3-gallery-next]')?.addEventListener('click', () => setGalleryImage(galleryIndex + 1));

  const carouselControllers = {};
  root.querySelectorAll('[data-lp3-carousel]').forEach((controls) => {
    const name = controls.dataset.lp3Carousel;
    const track = root.querySelector(`[data-lp3-carousel-track="${name}"]`);
    if (!track) return;
    const dots = [...controls.querySelectorAll('[data-lp3-carousel-dot]')];
    const visibleCards = () => [...track.children].filter((card) => !card.hidden);
    const currentIndex = () => {
      const cards = visibleCards();
      if (!cards.length) return 0;
      return cards.reduce((closest, card, index) => (
        Math.abs(card.offsetLeft - track.scrollLeft) < Math.abs(cards[closest].offsetLeft - track.scrollLeft) ? index : closest
      ), 0);
    };
    const update = () => {
      const cards = visibleCards();
      const activeIndex = currentIndex();
      dots.forEach((dot, index) => {
        dot.hidden = index >= cards.length;
        dot.classList.toggle('is-active', index === activeIndex && index < cards.length);
      });
    };
    const goTo = (index) => {
      const cards = visibleCards();
      if (!cards.length) return;
      const nextIndex = Math.max(0, Math.min(index, cards.length - 1));
      track.scrollTo({left: cards[nextIndex].offsetLeft, behavior: 'smooth'});
      window.setTimeout(update, 350);
    };
    controls.querySelector('[data-lp3-carousel-prev]')?.addEventListener('click', () => goTo(currentIndex() - 1));
    controls.querySelector('[data-lp3-carousel-next]')?.addEventListener('click', () => goTo(currentIndex() + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
    track.addEventListener('scroll', update, {passive: true});
    carouselControllers[name] = {update, goTo};
    update();
  });

  root.querySelectorAll('[data-lp3-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.lp3Filter;
      root.querySelectorAll('[data-lp3-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
      root.querySelectorAll('[data-lp3-result]').forEach((card) => {
        card.hidden = filter !== 'all' && card.dataset.lp3Result !== filter;
      });
      carouselControllers.results?.goTo(0);
      carouselControllers.results?.update();
    });
  });

  const sticky = root.querySelector('[data-lp3-sticky]');
  const purchase = root.querySelector('#lp3-purchase');
  const pageEnding = root.querySelector('.lp3-risk');
  if (sticky) {
    const updateSticky = () => {
      const progress = window.scrollY / Math.max(document.documentElement.scrollHeight - innerHeight, 1);
      const purchaseVisible = purchase && purchase.getBoundingClientRect().top < innerHeight && purchase.getBoundingClientRect().bottom > 0;
      const endingVisible = pageEnding && pageEnding.getBoundingClientRect().top < innerHeight;
      sticky.classList.toggle('is-visible', progress > 0.25 && !purchaseVisible);
      sticky.classList.toggle('is-suppressed', Boolean(endingVisible));
    };
    updateSticky();
    addEventListener('scroll', updateSticky, {passive: true});
  }
})();
